module.exports = __webpack_public_path__ + "img/WP2023-Icon-Indaba.86014f4c.svg";